import React from 'react';
import { Alert, Button, Box } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppDispatch, RootState } from '../reduxStore/Store';
import { setSelectedDepartement } from '../reduxStore/AppSlice';
import { isMultiDeptRoute } from '../constants/multiDeptRoutes';

/**
 * Wrapper appliqué aux routes incompatibles avec le mode "Tous départements".
 * En mode ALL, affiche une alerte invitant à sélectionner un dept (clic →
 * reset → DepartementSelectionPage). Sinon laisse passer le children.
 *
 * Exception : une route déclarée dans MULTI_DEPT_ROUTES sait fonctionner sans
 * département (ex: /parametre_generique gère les types GLOBAL en mode ALL) →
 * on la laisse passer même en mode ALL.
 */
const DeptRequiredRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { isAllMode } = useSelector((s: RootState) => s.AppSlice);
  const location = useLocation();

  if (!isAllMode || isMultiDeptRoute(location.pathname)) return <>{children}</>;

  return (
    <Box sx={{ p: 3 }}>
      <Alert
        severity="info"
        icon={<ApartmentIcon />}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => dispatch(setSelectedDepartement(null))}
          >
            Choisir un département
          </Button>
        }
      >
        Cette page nécessite un département. Sélectionnez-en un pour continuer.
      </Alert>
    </Box>
  );
};

export default DeptRequiredRoute;
